import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function FeaturedMovies() {
  const featured = hotMovies.slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              热门<span className="text-accent-500">推荐</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">全网最受欢迎的热门电影，口碑与热度兼备</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}